import React, { useEffect, useLayoutEffect, useState, useReducer } from 'react';
import { ComponentProps, PageProps } from './index.types';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { SkeletonPropertyCardLoaderComponent } from '../../../../molecules/skeletonPropertyCardLoader';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { HQVContext } from '../../../../context/HQVContext';
import { hqvInitialState, hqvReducer } from '../../../../reducers/HQV';
import { StyledFormContainer } from './SearchForm.styles';
import SearchFormComponent from './SearchFormComponent';
import { useHQVStore } from '../../../../modules/store/hqvZustandStore';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { FEATURE_FLAGS, FLAG_TYPE } from '@marriott/mi-feature-flag-utils';

const SearchForm: React.FC<ComponentProps> = pageProps => {
  const [loadForm, setLoadForm] = useState(false);
  const [state, dispatch] = useReducer(hqvReducer, hqvInitialState);

  const envVarsObject = useClientEnvVarsStore(state => state.envVarsObject);

  const [searchLoadForms, setSearchLoadForms] = useState(false);
  const [searchFormScrolled, setSearchFormScrolled] = useState(false);

  /**
   * Initialize HQV Zustand store when feature flag is enabled
   * This runs once on mount when enableAdfSearchForm is true
   */
  useLayoutEffect(() => {
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, FLAG_TYPE> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;
    const enableAdfSearchForm = (pageProps as unknown as PageProps)?.enableAdfSearchForm;

    if (shouldUseZustand && enableAdfSearchForm) {
      useHQVStore.getState().hqvInitialization(hqvInitialState);
    }
  }, [(pageProps as unknown as PageProps)?.enableAdfSearchForm, envVarsObject]);
  useEffect(() => {
    eventUtil.on('loadSearchForm', res => {
      setLoadForm(res);
    });
    document.addEventListener('scroll', () => {
      setSearchFormScrolled(true);
    });
    return () => {
      document.removeEventListener('scroll', () => {
        setSearchFormScrolled(false);
      });
    };
  }, []);

  const setSearchLoadForm = () => {
    setSearchLoadForms(true);
  };

  return (
    <StyledFormContainer
      className={
        (pageProps as unknown as PageProps)?.enableAdfSearchForm ||
        (pageProps as unknown as PageProps)?.cqType?.includes('mi-aem-shop-spa')
          ? searchFormScrolled
            ? 'serp-search-form-scrolled'
            : 'serp-search-form'
          : 'serp-search-form alternate'
      }
    >
      {!searchLoadForms && <SkeletonPropertyCardLoaderComponent isViewportL={true} isSearchForm={true} />}
      {loadForm &&
        ((pageProps as unknown as PageProps)?.enableAdfSearchForm ? (
          <HQVContext.Provider value={{ hqvState: state, hqvDispatch: dispatch }}>
            <SearchFormComponent pageProps={pageProps as unknown as PageProps} setSearchLoadForm={setSearchLoadForm} />
          </HQVContext.Provider>
        ) : (
          <SearchFormComponent pageProps={pageProps as unknown as PageProps} setSearchLoadForm={setSearchLoadForm} />
        ))}
    </StyledFormContainer>
  );
};

export default SearchForm;
//Config for aem editable components
export const SearchFormConfig = {
  emptyLabel: 'SearchForm',
  isEmpty: false,
  //tobe changed
  resourceType: `mi-aem-shop-spa/components/content/searchform/v1/searchform`,
};
//Component wrapped with editable component for aem authoring
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SearchFormComponentEditable = (props: any) =>
  props.cqPath.includes('experiencefragment') ? (
    <SearchForm {...props} />
  ) : (
    <EditableComponent config={SearchFormConfig} {...props}>
      <SearchForm {...props} />
    </EditableComponent>
  );
